@use "variables" as *;

.resultsWrapper {
  margin-bottom: $spacing-2;
}

.results {
  color: $content-secondary-color;
}
